import { IrregularidadeEmpresaCadastroComponent } from './cadastro/irregularidade_empresa.cadastro.component';
import { IrregularidadeEmpresaPesquisaComponent } from './pesquisa/irregularidade_empresa.pesquisa.component';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { IrregularidadeEmpresaRoutingModule } from './irregularidade_empresa-routing.module';
import { SharedModule } from "src/app/shared/shared.module";
import { NgModule } from '@angular/core';
import { IrregularidadeEmpresaListagemComponent } from './pesquisa/listagem/irregularidade_empresa.listagem.component';


@NgModule({
  imports:[
      SharedModule,
      BrowserModule,
      CommonModule,
      IrregularidadeEmpresaRoutingModule
  ],
  declarations:[
      IrregularidadeEmpresaPesquisaComponent,
      IrregularidadeEmpresaListagemComponent,
      IrregularidadeEmpresaCadastroComponent
  ],
  providers:[

  ]
})
export class IrregularidadeEmpresaModule{}
